import { HierarchyContextProps } from "contexts/hierarchy/interface";
import { eAccessRights, eReleaseStatus } from "functions/api/enums";
import { TlfContextProps } from "./interface";

/**
 * Determines whether the current user may edit the loaded TLF, including through history commands.
 *
 * @param tlfState - Current TLF data and route-level read-only flag.
 * @param hierarchyState - Active hierarchy backup status and the user's access rights.
 * @returns Whether TLF edits must be prohibited for the current route and release status.
 */
export const isTlfReadOnly = (
  tlfState: TlfContextProps,
  hierarchyState: HierarchyContextProps,
): boolean =>
  tlfState.readOnly ||
  hierarchyState.hierarchy?.isBackupVersion === true ||
  !hierarchyState.accessRights.includes(eAccessRights.WriteToTlfItemsInHierarchy) ||
  (tlfState.tlfData !== null &&
    ![eReleaseStatus.Draft, eReleaseStatus.ReleasePending].includes(
      tlfState.tlfData.releaseStatus,
    ));
